import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import './CustomerChoice.css';
import RadioButton from "../common/radioButton/RadioButton";
import RegulationAcceptance from "../regulationAcceptance/RegulationAcceptance";
import { getCustomer, setCustomerType } from "../../features/customer/customerSlice";
import { setComplaintType, setCreatedDate } from '../../features/complaint/ComplaintSlice';
import { getComplaint, setSelectClient, setSelectComplaintType } from "../../features/complaintTypes/ComplaintTypesSlice";   
import moment from 'moment';

const CustomerChoice = ({ isChoiceCompanySelected, onChoiceSelected, isChoiceSelected }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const complaintTypes = useSelector((state) => state.complaintTypes.complaintTypes);
  const [selectedOption, setSelectedOption] = useState(null);
  const isTermOfUseAccepted = useSelector((state) => state.complaint.isTermOfUseAccepted);
  const selectedClient = useSelector((state) => state.complaintTypes.selectedClient);
  const privatePersonType = useSelector((state) => state.customer.type[2]);

  useEffect(() => {
    dispatch(getComplaint());
    dispatch(getCustomer());
  }, [dispatch]);

  const handleOptionClick = (option) => {
    dispatch(getComplaint(option.name));
    setSelectedOption(option.displayName);
    dispatch(setSelectClient(selectedClient));
    dispatch(setComplaintType({
      id: option.id,
      name: option.complaintType,
      displayName: option.displayName
    }));

    if (privatePersonType) {
      dispatch(setCustomerType({
        id: privatePersonType.customerId,
        displayName: privatePersonType.displayName,
        customerType: privatePersonType.customerType,
        description: privatePersonType.description,
        value: privatePersonType.name
      }));
    }

    if (!isChoiceSelected) {
      onChoiceSelected("CustomerChoice");
    }

    dispatch(setCreatedDate(moment()));
  };

  const validateForm = () => {
    if (isTermOfUseAccepted && selectedOption) {
      navigate('/information');
    }
  };
 
  return (
    <div className="card"> {/* globalny kontener */}
      <div className="card-header">
        <h5 className="view-title">Klient indywidualny</h5>
        <p className="subtitle">(osoba nie prowadząca działalności gospodarczej)</p>
      </div>

      <div className="card-body">
        <p className="section-title">Możesz zgłosić:</p>

        {Object.values(complaintTypes)
          .filter(customer => customer.customerId === 1)
          .flatMap(customer => customer.complaintTypes.map(option => (
            <div className="option-row" key={option.id}>
              <RadioButton
                id={option.id}
                name={option.name}
                value={option.displayName}
                onClick={() => handleOptionClick(option)}
                checked={selectedOption === option.displayName && !isChoiceCompanySelected}
              />
              <p 
                className="option-label" 
                onClick={() => handleOptionClick(option)}
              >
                {option.displayName}
              </p>
            </div>
          )))
        }

        {selectedOption && !isChoiceCompanySelected && (
          <div className="form-footer">
            <RegulationAcceptance 
              checked={isTermOfUseAccepted} 
              selectedOption={selectedOption} 
              complaintTypes={complaintTypes} 
              selectedClient={selectedClient}
            />
            <button 
              className="btn btn-secondary" 
              type="button" 
              onClick={validateForm}
            >
              Dodaj zgłoszenie
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerChoice;
